export default __webpack_public_path__ + "static/media/search_hero.12ced8dc.png";